// REACT
import React from "react";
import { useTranslation } from "react-i18next";

// ANT COMPONENT
import { InboxOutlined } from "@ant-design/icons";
import { Upload as AntUpload } from "antd";
import { Button } from "@life-line-lab/components-react";

// HELPER
import { toaster } from "Helpers/toaster";
import "./upload.scss";

interface UploadProps {
  multiple?: boolean;
  uploadIcon?: React.ReactNode;
  uploadText?: React.ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
  onRemove: (file) => void;
  onChange: (file) => void;
  fileList: any;
  fileFormat?: string;
}

const Upload: React.FC<UploadProps> = ({
  multiple = false,
  uploadIcon,
  uploadText,
  onConfirm,
  onCancel,
  onRemove,
  onChange,
  fileList,
  fileFormat = ".png, .jpg, .jpeg",
}) => {
  const { Dragger } = AntUpload;
  const { t } = useTranslation();

  const props = {
    // fileList={featureImage}
    // onChange={onChangeFeature}
    // maxCount={1}
    // onPreview={onPreview}
    // onRemove={imageRemove}
    maxCount: 1,
    accept: fileFormat,
    onChange: onChange,
    onRemove: onRemove,
    onDrop(e) {},
  };

  return (
    <React.Fragment>
      <Dragger
        {...props}
        style={{ height: "150px", maxHeight: "300px" }}
        beforeUpload={() => false}
        fileList={fileList}
        listType="picture"
      >
        <p className="ant-upload-drag-icon">{uploadIcon ? uploadIcon : <InboxOutlined />}</p>
        {uploadText ? (
          uploadText
        ) : (
          <p className="ant-upload-text p-10">Click or drag file to this area to upload</p>
        )}
      </Dragger>
      <div className="ant-upload-btn-container">
        <Button
          label={t("action.cancel")}
          onClick={onCancel}
          type="primary"
          className="btn--ghost"
        />
        <Button label={t("action.confirm")} onClick={onConfirm} type="primary" />
      </div>
    </React.Fragment>
  );
};

export default Upload;
